import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Skeleton, Spin } from 'antd';
import { BlockNames } from '../block.types';

const LazyBlockDevelopmentPage = React.lazy(() => import('./BlockDevelopment'));
export const AsyncBlockDevelopmentPage: React.FC<{ piletApi: PiletApi }> = props => (
	<React.Suspense fallback={<Spin />}>
		<LazyBlockDevelopmentPage {...props} />
	</React.Suspense>
);

export function addBlock(piletApi: PiletApi) {
	const LazyClientTools = React.lazy(() => import('../Tools'));
	piletApi.registerExtension(BlockNames.ClientTools, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyClientTools {...props} />
		</React.Suspense>
	));

	const LazyMacTools = React.lazy(() => import('../Tools/Mac'));
	piletApi.registerExtension(BlockNames.MacTools, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyMacTools {...props} />
		</React.Suspense>
	));

	const LazyWindowsTools = React.lazy(() => import('../Tools/Windows'));
	piletApi.registerExtension(BlockNames.WindowsTools, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyWindowsTools {...props} />
		</React.Suspense>
	));

	const LazyMobileTools = React.lazy(() => import('../Tools/Mobile'));
	piletApi.registerExtension(BlockNames.MobileTools, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyMobileTools {...props} />
		</React.Suspense>
	));

	const LazyRecentFilesBlock = React.lazy(
		() => import('../RecentFiles/RecentFilesBlock')
	);
	piletApi.registerExtension(BlockNames.RecentFiles, props => (
		<React.Suspense fallback={<Skeleton />}>
			<LazyRecentFilesBlock {...props} />
		</React.Suspense>
	));

	const LazyFavoritesBlock = React.lazy(
		() => import('../Folders/Favorites/FavoritesBlock')
	);
	piletApi.registerExtension(BlockNames.Favorites, props => (
		<React.Suspense fallback={<Skeleton />}>
			<LazyFavoritesBlock {...props} />
		</React.Suspense>
	));

	const LazyFileViewer = React.lazy(() => import('./FileViewerBlock'));
	piletApi.registerExtension(BlockNames.FileViewer, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyFileViewer {...props} />
		</React.Suspense>
	));

	const LazyClientSettingsPage = React.lazy(() => import('../Settings/ClientSettings'));
	piletApi.registerExtension(BlockNames.SettingsPage, props => (
		<React.Suspense fallback={<Spin />}>
			<LazyClientSettingsPage {...props} />
		</React.Suspense>
	));
}
